import { appstr } from "../utils/appstr";
import { QAlert } from "./QAlert";
import { QRFC } from "./QRFC";
import { Globals } from "./Globals";
export class QBuildPlanRFC extends QRFC {
  constructor() {
    super();
  }

  InitUpdatePlans(callbackObj) {
    this.InitRemoteCall(callbackObj, "POST", true, false);
  }

  GetCallName() {
    return "planning/qplanrfc";
  }

  SetParams(orgName, user, mode, data, emailInvite = null) {
    this.AddParameter("data", data);
    this.AddParameter("mode", mode);
    this.AddParameter("org", orgName);
    this.AddParameter("user", user);
    if (emailInvite != null) this.AddParameter("emailInvite", emailInvite);
  }

  DoTransactionComplete(response, callBackObj) {
    var wsMgr = callBackObj;
    var r = JSON.parse(response);
    var success = r["success"];

    if (Globals._wsMgr.fWaiting) {
      Globals._wsMgr.ClearAppLoadingAnimation();
      Globals._wsMgr.fWaiting = null;
    }
    if (!success) {
      var alert = new QAlert();
      alert.InitAlert(
        appstr("Unable to Save Changes"),
        appstr("SystemError") +
          "\n" +
          appstr("Error") +
          ": " +
          "'" +
          r["message"] +
          "'" +
          ", Code: " +
          r["code"],
        wsMgr,
        wsMgr
      );
      wsMgr.PrepRenderWS();
      wsMgr.RenderWS();
      return;
    } else if (r["plans"]) {
      callBackObj.fPlanInfo = r["plans"];
      //callBackObj.UpdatePanel();
      //wsMgr.PrepRenderWS();
      //wsMgr.RenderWS();
    } else {
      var planID = r["plan"]["ID"];
      Globals._svrChartMgr.SetLastPlanID(planID);
      wsMgr.OpenPlan(planID);
      wsMgr.GetUsageTracker().ReportEvent("planning.plan.created", {
        plan_type: this.fIsPositionChart ? "position" : "employee"
      });
    }

    if (callBackObj.onResult) callBackObj.onResult(success, r);
  }
}
